import { useEffect, useState } from "react";
import CmxDate from "../ui/DateTime";
import { CmxComboBox } from "../ui/Input";
import MultiSelect from "../ui/MultiSelect";
import "./style.css";

const Filtros = ({
  filters,
  setFilters,
  tiposChamado,
  situacoesChamado,
  areas,
  servicoProdutoOptions = [],
  clienteOptions = [],
  clienteDisabled = false,
}) => {
  // filters já chega pronto (o pai o inicializa a partir do localStorage),
  // então os inputs de data só precisam espelhar o valor inicial recebido.
  const [abertoDe, setAbertoDe] = useState(() =>
    filters.abertoDe !== "01/07/2010" ? filters.abertoDe : "",
  );
  const [abertoAte, setAbertoAte] = useState(() =>
    filters.abertoAte !== "31/12/2100" ? filters.abertoAte : "",
  );
  // "Encerrado de/até" (era "Baixado de/até" até 2026-09-18): filtra por
  // z_chamados.data_encerramento, o carimbo do ato terminal que o Raptor e o Lizard usam hoje.
  const [encerradoDe, setEncerradoDe] = useState(() => filters.encerradoDe || "");
  const [encerradoAte, setEncerradoAte] = useState(() => filters.encerradoAte || "");

  useEffect(() => {
    // Salvar filtros no localStorage quando os filtros são atualizados
    localStorage.setItem("cmx_filters", JSON.stringify(filters));
  }, [filters]);

  useEffect(() => {
    // Sanitizar seleção de Serviço/Produto quando opções mudarem
    if (Array.isArray(servicoProdutoOptions)) {
      const atuais = Array.isArray(filters.servico_produto)
        ? filters.servico_produto
        : [];
      const validas = atuais.filter((d) => servicoProdutoOptions.includes(d));
      if (validas.length !== atuais.length) {
        setFilters({
          ...filters,
          servico_produto: validas,
        });
      }
    }
  }, [servicoProdutoOptions]);

  useEffect(() => {
    // Garante um cliente_id válido: mantém o já selecionado (última
    // preferência do usuário) se ainda estiver entre as opções, ou
    // sugere o primeiro cliente disponível como padrão.
    // Enquanto clienteOptions ainda está vazio (usuário ainda carregando no
    // AuthContext, que libera loading=false antes da resposta de
    // /usuario/info chegar), não mexe em nada: uma lista vazia aqui significa
    // "ainda não sei", não "cliente inválido" — sem essa guarda, o cliente_id
    // restaurado do localStorage era zerado antes do usuário real chegar.
    const opcoes = Array.isArray(clienteOptions) ? clienteOptions : [];
    if (opcoes.length === 0) return;

    setFilters((atuais) => {
      const atualId = `${atuais.cliente_id || ""}`;
      const aindaValido = opcoes.some((c) => `${c.id}` === atualId);
      const primeiro = `${opcoes[0].id}`;
      const novoId = aindaValido ? atualId : primeiro;
      const servicoProduto = novoId ? atuais.servico_produto || [] : [];

      if (
        novoId !== atualId ||
        (Array.isArray(atuais.servico_produto) &&
          servicoProduto.length !== atuais.servico_produto.length)
      ) {
        return { ...atuais, cliente_id: novoId, servico_produto: servicoProduto };
      }
      return atuais;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteOptions, clienteDisabled]);

  const handleSetFilter = (name, value) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateChange = (name, value) => {
    handleSetFilter(name, value);
    if (name === "abertoDe") {
      setAbertoDe(value);
    } else if (name === "abertoAte") {
      setAbertoAte(value);
    } else if (name === "encerradoDe") {
      setEncerradoDe(value);
    } else if (name === "encerradoAte") {
      setEncerradoAte(value);
    }
  };

  return (
    <div className="filtro" style={{}}>
      <div className="row">
        <div className="col col-3">
          <label className="titulo">Aberto de</label>
          <CmxDate
            placeholder={"Início"}
            inputValue={abertoDe}
            setInputValue={(value) => handleDateChange("abertoDe", value)}
            type="text"
          />
        </div>
        <div className="col col-3">
          <label className="titulo">Aberto até</label>
          <CmxDate
            placeholder={"Fim"}
            inputValue={abertoAte}
            setInputValue={(value) => handleDateChange("abertoAte", value)}
            type="text"
          />
        </div>
        <div className="col col-3">
          <label className="titulo">Encerrado de</label>
          <CmxDate
            placeholder={"Início"}
            inputValue={encerradoDe}
            setInputValue={(value) => handleDateChange("encerradoDe", value)}
            type="text"
          />
        </div>
        <div className="col col-3">
          <label className="titulo">Encerrado até</label>
          <CmxDate
            placeholder={"Fim"}
            inputValue={encerradoAte}
            setInputValue={(value) => handleDateChange("encerradoAte", value)}
            type="text"
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-3">
          <label className="titulo">Situação Chamado</label>
          <MultiSelect
            options={situacoesChamado}
            selectedOptions={filters.situacaoChamado}
            setSelectedOptions={(value) =>
              handleSetFilter("situacaoChamado", value)
            }
            label="Situação Chamado"
            uniqueId={"situacaoChamado"}
          />
        </div>
        <div className="col col-3">
          <label className="titulo">Tipo Chamado</label>
          <MultiSelect
            options={tiposChamado}
            selectedOptions={filters.tipoChamado}
            setSelectedOptions={(value) =>
              handleSetFilter("tipoChamado", value)
            }
            label="Tipo Chamado"
            uniqueId={"tipoChamado"}
          />
        </div>
        <div className="col col-3">
          <label className="titulo">Cliente</label>
          <CmxComboBox
            value={filters.cliente_id || ""}
            disabled={clienteDisabled}
            onChange={(e) => handleSetFilter("cliente_id", e.target.value)}
          >
            <option value="">
              {clienteDisabled ? "--Cliente definido--" : "--Selecione um Cliente"}
            </option>
            {clienteOptions.map((cliente) => (
              <option key={cliente.id} value={cliente.id}>
                {cliente.label}
              </option>
            ))}
          </CmxComboBox>
        </div>
        <div className="col col-3">
          <label className="titulo">Serviço/Produto</label>
          <MultiSelect
            options={servicoProdutoOptions}
            selectedOptions={filters.servico_produto || []}
            setSelectedOptions={(value) =>
              handleSetFilter("servico_produto", value)
            }
            label="Serviço/Produto"
            uniqueId={"servico_produto"}
          />
        </div>
      </div>
    </div>
  );
};

export default Filtros;
